import React from 'react';
import { connect } from 'react-redux';
import { CustomerState, actionCreators, CallState, PaymentState } from '../store/Customer';
import { ApplicationState } from '../store';
import { Button, Container, Col, Row, Table } from 'reactstrap';
import "./PaymentResult.css";
import { render } from 'react-dom';
import _ from 'lodash';
import config from "../store/config";

type PaymentResultProps = typeof actionCreators & React.Props<{}> & { customer: CustomerState };

export class PaymentResult extends React.Component<PaymentResultProps> {    

    paymentFailed = false;
    paymentRef = "";
    isCancelled = false;

    constructor(props: PaymentResultProps) {

        super(props);

        const urlParams = new URLSearchParams(window.location.search);
        const failed = urlParams.get('failed');
        const ref = urlParams.get('ref');
        const reason = urlParams.get('reason');
        
        
        this.isCancelled = reason && reason === 'cancelled';
        this.paymentFailed = (failed && failed == 'true') ? true : false;
        this.paymentRef = ref;

        if (!this.paymentFailed) {
            setTimeout(() => {
                if (!config.brand || (config.brand && config.brand) == 'abg') window.location.href = "https://www.alanboswell.com/";
                if (config.brand && config.brand == 'stech') window.location.href = "https://www.s-tech.co.uk/";
            }, 10000);
        }

    }    

    render() {

        const { customer } = this.props; 

        return (

            <div style={{ margin: "2em 0" }}>

                {this.paymentFailed && !this.isCancelled &&

                    <div>

                        <h2 className="section_title mb-4">Payment Failed</h2>

                        <p className="page-details-text">Unfortunately we haven't been able to take a card payment; the card details you have supplied can't be processed by our card payment partner. To ensure your cover stays in place, you can call us on 01603 218000 during office hours to speak with one of our team and pay over the phone. </p>

                        {/*<Button onClick={_ => props.onClose()}>Return To Main Screen</Button>*/}

                    </div>

                }

                {this.paymentFailed && this.isCancelled &&

                    <div>

                        <h2 className="section_title mb-4">Payment Cancelled</h2>

                        <p className="page-details-text">To ensure your cover stays in place, you can call us on 01603 218000 during office hours to speak with one of our team and pay over the phone. </p>

                        {/*<Button onClick={_ => props.onClose()}>Return To Main Screen</Button>*/}

                    </div>

                }

                {!this.paymentFailed &&

                    <div>

                        <h2 className="section_title mb-4">Successful Payment</h2>

                        <p className="page-details-text">Thank you for your payment. We will send you an email confirmation shortly.</p>

                        {/*<Button onClick={_ => props.onClose()}>Return To Main Screen</Button>*/}

                    </div>

                }

            </div>

        )
    };

};

export default connect(
    (state: ApplicationState) => ({ customer: state.customer }),
    actionCreators
)(PaymentResult);